import { wordOfNumber } from '@/utils/format'

import { types } from '@/models/tasks'

export const projectTimelineTypes = {
  ACCEPTANCE_OF_WORK: types.ACCEPTANCE_OF_WORK,
  DEFECTS_AND_VIOLATIONS: types.DEFECTS_AND_VIOLATIONS,
  DEFECTS_AND_VIOLATIONS_FINISHED: `${types.DEFECTS_AND_VIOLATIONS}_finished`,
  APPROVAL_PROCESS: types.APPROVAL_PROCESS,
  APPROVAL_PROCESS_APPROVED: `${types.APPROVAL_PROCESS}_approved`,
  DOCUMENTS: 'documents',
  PHOTOS: 'photos'
}

export const getTimelineLabel = (count, displayedCount, type) => {
  const dif = count - displayedCount

  return ({
    [projectTimelineTypes.ACCEPTANCE_OF_WORK]: {
      prefix: 'Приемка работ',
      text: `${count} ${wordOfNumber(count, ['вызов', 'вызова', 'вызовов'])}`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['вызов', 'вызова', 'вызовов'])}`
    },
    [projectTimelineTypes.DEFECTS_AND_VIOLATIONS]: {
      prefix: 'Создано',
      text: `${count} ${wordOfNumber(count, ['предписание', 'предписания', 'предписаний'])}`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['предписание', 'предписания', 'предписаний'])}`
    },
    [projectTimelineTypes.DEFECTS_AND_VIOLATIONS_FINISHED]: {
      prefix: 'Закрыто',
      text: `${count} ${wordOfNumber(count, ['предписание', 'предписания', 'предписаний'])}`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['предписание', 'предписания', 'предписаний'])}`
    },
    [projectTimelineTypes.APPROVAL_PROCESS]: {
      prefix: wordOfNumber(count, ['Загружен', 'Загружено', 'Загружено']),
      text: `${count} ${wordOfNumber(count, ['документ', 'документа', 'документов'])} на согласование`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['документ', 'документа', 'документов'])} на согласование`
    },
    [projectTimelineTypes.APPROVAL_PROCESS_APPROVED]: {
      prefix: wordOfNumber(count, ['Согласован', 'Согласовано', 'Согласовано']),
      text: `${count} ${wordOfNumber(count, ['документ', 'документа', 'документов'])}`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['документ', 'документа', 'документов'])}`
    },
    [projectTimelineTypes.DOCUMENTS]: {
      prefix: wordOfNumber(count, ['Загружен', 'Загружено', 'Загружено']),
      text: `${count} ${wordOfNumber(count, ['новый документ', 'новых документа', 'новых документов'])}`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['новый документ', 'новых документа', 'новых документов'])}`
    },
    [projectTimelineTypes.PHOTOS]: {
      prefix: wordOfNumber(count, ['Загружена', 'Загружено', 'Загружено']),
      text: `${count} ${wordOfNumber(count, ['фотография', 'фотографии', 'фотографий'])}`,
      more: `+ еще ${dif} ${wordOfNumber(dif, ['фотография', 'фотографии', 'фотографий'])}`
    }
  })[type]
}